import React from 'react';
import { ArrowRight, Facebook, Instagram, Mail, MapPin, Phone } from 'lucide-react';
import { company, navLinks, serviceAreas, services } from '../data/site';
export function Footer() {
  return <footer className="w-full bg-navy-900 pt-20 text-white" data-id="element-173" data-mp="32oe11y52qfc8">
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8" data-id="element-174" data-mp="32lrnnhvi55m3">
        <div className="grid gap-12 border-b border-white/10 pb-16 lg:grid-cols-12" data-id="element-175" data-mp="36q93j5yqqyrl">
          <div className="lg:col-span-4" data-id="element-176" data-mp="3ues8bbil0tex">
            <span className="inline-flex bg-white px-4 py-3" data-id="element-177" data-mp="3ucxo5zf4x5bw">
              <img src={company.logo} alt={`${company.name} logo`} className="h-12 w-auto" data-id="element-178" data-mp="37o74x94c1ef" />
            </span>
            <p className="mt-7 max-w-sm text-sm leading-relaxed text-white/50" data-id="element-179" data-mp="3ldkgncakmqtt">
              Locally owned general construction serving {company.region}. Quality craftsmanship, clear communication,
              and work built to last.
            </p>
            <div className="mt-7 flex gap-3" data-id="element-180" data-mp="2ey09e8qeiii6">
              <a href="https://www.facebook.com" target="_blank" rel="noreferrer" aria-label="Pure Build Construction on Facebook" className="inline-flex h-11 w-11 items-center justify-center border border-white/15 text-white/60 transition hover:border-brand-500 hover:bg-brand-500 hover:text-white" data-id="element-181" data-mp="2ezuv3p9hyenb">
                <Facebook className="h-4 w-4" aria-hidden="true" data-id="element-182" data-mp="3q7ty7fo7a9v7" />
              </a>
              <a href="https://www.instagram.com" target="_blank" rel="noreferrer" aria-label="Pure Build Construction on Instagram" className="inline-flex h-11 w-11 items-center justify-center border border-white/15 text-white/60 transition hover:border-brand-500 hover:bg-brand-500 hover:text-white" data-id="element-183" data-mp="81yvyfozns2e">
                <Instagram className="h-4 w-4" aria-hidden="true" data-id="element-184" data-mp="qujm3pdazj2i" />
              </a>
            </div>
          </div>

          <nav aria-label="Footer navigation" className="lg:col-span-2" data-id="element-185" data-mp="mthjcyk6govs">
            <h2 className="text-[11px] font-bold uppercase tracking-[0.2em] text-white" data-id="element-186" data-mp="tvw84i1avhgi">Navigate</h2>
            <ul className="mt-6 space-y-3 text-sm text-white/50" data-id="element-187" data-mp="ytef42vrbmlv">
              {navLinks.map(l => <li key={l.href} data-id="element-188" data-mp="13s98fyrcotk8">
                  <a href={l.href} className="transition hover:text-brand-400" data-id="element-189" data-mp="13r7lox0z2imo">
                    {l.label}
                  </a>
                </li>)}
            </ul>
          </nav>

          <nav aria-label="Services" className="lg:col-span-3" data-id="element-190" data-mp="1cnp0qbcgj0np">
            <h2 className="text-[11px] font-bold uppercase tracking-[0.2em] text-white" data-id="element-191" data-mp="1hjnqo3dfoqq8">Services</h2>
            <ul className="mt-6 space-y-3 text-sm text-white/50" data-id="element-192" data-mp="1ml3fm6iqfhdw">
              {services.map(s => <li key={s.id} data-id="element-193" data-mp="1rhk08qqq3dm8">
                  <a href="#services" className="transition hover:text-brand-400" data-id="element-194" data-mp="1rgisav50778q">
                    {s.title}
                  </a>
                </li>)}
            </ul>
          </nav>

          <div className="lg:col-span-3" data-id="element-195" data-mp="3tc2u8v1bkne0">
            <h2 className="text-[11px] font-bold uppercase tracking-[0.2em] text-white" data-id="element-196" data-mp="2ag5fwt1bdghp">Contact</h2>
            <ul className="mt-6 space-y-4 text-sm text-white/50" data-id="element-197" data-mp="25ncbk69rca65">
              <li className="flex gap-3" data-id="element-198" data-mp="21mtiya01j02w">
                <Phone className="mt-0.5 h-4 w-4 shrink-0 text-brand-500" aria-hidden="true" data-id="element-199" data-mp="21nlclfa2unqj" />
                <a href={company.phoneHref} className="transition hover:text-brand-400" data-id="element-200" data-mp="1wos1fti9j8tj">
                  {company.phone}
                </a>
              </li>
              <li className="flex gap-3" data-id="element-201" data-mp="2pcnrifdbu2hc">
                <Mail className="mt-0.5 h-4 w-4 shrink-0 text-brand-500" aria-hidden="true" data-id="element-202" data-mp="2pdpe9h3pgdew" />
                <a href={`mailto:${company.email}`} className="break-all transition hover:text-brand-400" data-id="element-203" data-mp="2kc02u0cklxqa">
                  {company.email}
                </a>
              </li>
              <li className="flex gap-3" data-id="element-204" data-mp="18yefmkq9u67e">
                <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-brand-500" aria-hidden="true" data-id="element-205" data-mp="18zft0vurf4sa" />
                <span data-id="element-206" data-mp="13xqdp40i84ye">
                  {company.addressLine1}
                  <br data-id="element-207" data-mp="2rvhdvhf1bz4w" />
                  {company.addressLine2}
                </span>
              </li>
            </ul>
            <a href={company.mapsLink} target="_blank" rel="noreferrer" className="group mt-7 inline-flex items-center gap-3 border-b-2 border-white/25 pb-2 text-[12px] font-bold uppercase tracking-[0.16em] text-white transition hover:border-brand-500 hover:text-brand-400" data-id="element-208" data-mp="2wn96rylnygy7">
              Get Directions
              <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1.5" aria-hidden="true" data-id="element-209" data-mp="3fllldzvcgj16" />
            </a>
          </div>
        </div>

        <div className="flex flex-col gap-3 py-8 text-[11px] uppercase tracking-[0.14em] text-white/35 sm:flex-row sm:items-center sm:justify-between" data-id="element-210" data-mp="36knglfd307hj">
          <p data-id="element-211" data-mp="1q4sukmr8ajom">© 2026 {company.name}. All Rights Reserved.</p>
          <p className="normal-case tracking-normal text-white/30" data-id="element-212" data-mp="1v602cltdfiva">
            Serving {serviceAreas.slice(0, 5).join(', ')} and surrounding areas
          </p>
        </div>
      </div>
    </footer>;
}